import { Component, HostListener, ViewChild } from '@angular/core';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common/common.service';
import { CompanyUserConstant } from 'src/app/constants/label-constants';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CompanyUserModel } from 'src/app/models/companyUserModel';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { commonErrorMessage, companyErrorPageMessage } from 'src/app/constants/error-message-constant';
interface company {
  companyId: any;
  companyName: string;
}
interface AdminRole {
  adminRoleId: any;
  adminRoleName: string;
}
@Component({
  selector: 'app-company-user-add-edit',
  templateUrl: './company-user-add-edit.component.html',
  styleUrls: ['./company-user-add-edit.component.scss']
})
export class CompanyUserAddEditComponent {
  UserForm: FormGroup = this.formBuilder.group({});
  AdminRoleList: any = [];
  CompanyList: any = [];
  userId: number = 0;
  commonConstant: any = [];
  commonErrorMessage: any = [];
  errorMessage: any = [];
  modalButton: boolean = false;
  CompanyUserConstant: any = [];
  flag: boolean = false;
  protected AllCompanylist: company[] = this.CompanyList;
  protected AllAdminlist: AdminRole[] = this.AdminRoleList;
  public Ctrl: FormControl = new FormControl();
  public FilterCtrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public filteredAdminData: ReplaySubject<any> = new ReplaySubject();

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.UserForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  protected _onDestroy = new Subject();

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  protected filtercompany() {
    if (!this.AllCompanylist) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.AllCompanylist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.AllCompanylist.filter(data => data.companyName.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterAdmin() {
    if (!this.AllAdminlist) {
      return;
    }
    let search = this.Ctrl.value;
    if (!search) {
      this.filteredAdminData.next(this.AllAdminlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredAdminData.next(
      this.AllAdminlist.filter(data => data.adminRoleName.toLowerCase().indexOf(search) > -1)
    );
  }

  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  async ngOnInit(): Promise<void> {
    this.Ctrl.setValue(this.AllCompanylist[1]);
    this.filteredData.next(this.AllCompanylist.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtercompany();
      });
    this.Ctrl.setValue(this.AllAdminlist[1]);
    this.filteredAdminData.next(this.AllAdminlist.slice());
    this.Ctrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterAdmin();
      });
    this.spinner.show();
    this.CompanyUserConstant = CompanyUserConstant;
    this.commonConstant = CommonConstant;
    this.errorMessage = companyErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.onInitUserForm();
    if (this.userId > 0) {
      this.getUserDetail(this.userId);
    }
    else {
      this.userId = 0;
    }
    await this.getAdminRoleList();
    this.getCompanyList();
  }

  onInitUserForm() {
    this.UserForm = this.formBuilder.group({
      userId: [0],
      FirstName: ['', [Validators.required]],
      LastName: ['', [Validators.required]],
      EmailId: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      MobileNo: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
      adminRoleId: ['', [Validators.required]],
      CompanyId: ['', [Validators.required]],
    });
  }

  get userFormControl() {
    return this.UserForm.controls;
  }

  onCancel() {
    if (this.UserForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.UserForm = this.UserForm;
    }
    else {
      this.modalService.close();
    }
  }

  getUserDetail(userId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.companyUser.GetCompanyById.replace("{id}", userId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.spinner.hide();
        this.setUserForm(data.data[0]);
      },
      error: (err) => {
        this.spinner.hide();
        console.log('getGetUserById-Error', err);
      }
    });
  }

  setUserForm(data) {
    this.UserForm.setValue({
      userId: (data.userId) ? data.userId : 0,
      FirstName: data.firstName != '' ? data.firstName : '',
      LastName: data.lastName != '' ? data.lastName : '',
      EmailId: data.emailId.toLowerCase(),
      MobileNo: data.mobileNo,
      adminRoleId: data.adminRoleId,
      CompanyId: data.companyId,
    });
    // this.UserForm.get('EmailId')?.disable();
  }

  async getAdminRoleList() {
    const apiUrl = this.apiUrl.apiUrl.user.CompanyRoleList;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          this.AdminRoleList = data.data.filter(d => d.adminRoleId && d.adminRoleName);
        }
        this.AllAdminlist = this.AdminRoleList;
        this.filterAdmin();
      },
      error: (err) => {
        console.log('getRoleList-Error', err);
      }
    });
  }

  getCompanyList() {
    const apiUrl = this.apiUrl.apiUrl.companyUser.GetCompanyList;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          this.CompanyList = data.data.filter(d => d.companyId && d.companyName);
        }
        this.AllCompanylist = this.CompanyList;
        this.filtercompany();
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getCompanyList-Error', err);
      }
    });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  saveUser() {
    this.modalButton = true;
    if (!this.UserForm.valid) {
      return;
    }
    this.spinner.show();
    const objData: CompanyUserModel = {
      UserId: !this.UserForm.value.userId ? 0 : this.UserForm.value.userId,
      FirstName: this.UserForm.value.FirstName,
      LastName: this.UserForm.value.LastName,
      EmailId: this.UserForm.value.EmailId.toLowerCase().trim(),
      MobileNo: this.UserForm.value.MobileNo,
      adminRoleId: this.UserForm.value.adminRoleId,
      companyId: this.UserForm.value.CompanyId
    }
    const apiUrl = this.apiUrl.apiUrl.companyUser.SaveCompanyUser;
    this.CommonService.doPost(apiUrl, objData).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.modalService.close('save');
          this.toastr.success(data.message);
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }
}
